import { Globe } from 'lucide-react';

const iconClassName = 'h-4 w-4 shrink-0';

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3A2.05 2.05 0 1 0 5.3 7.1 2.05 2.05 0 0 0 5.25 3Zm5.27 5.5H7.28V20h3.24v-6.05c0-1.6.3-3.15 2.28-3.15 1.95 0 1.98 1.82 1.98 3.25V20H18V13.4c0-3.25-.7-5.75-4.5-5.75-1.83 0-3.05 1-3.55 1.95h-.05V8.5h.62Z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M13.36 20v-6.62h2.2l.33-2.58h-2.53V9.15c0-.74.2-1.25 1.27-1.25H16V5.59c-.25-.03-1.09-.09-2.08-.09-2.05 0-3.45 1.25-3.45 3.56v1.74H8.25v2.58h2.22V20h2.89Z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
    <circle cx="12" cy="12" r="3.8" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M18.9 3H21l-4.58 5.23L21.8 21h-4.2l-3.3-4.98L9.95 21H7.85l4.9-5.6L2.5 3h4.3l2.98 4.5L13.7 3h2.1l-5.02 5.74 3.52 5.31L18.9 3Z" />
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName}>
    <path fill="#EA4335" d="M12.22 10.18v3.9h5.42a4.64 4.64 0 0 1-2.02 3.05l3.27 2.54c1.9-1.75 3-4.32 3-7.4 0-.67-.06-1.31-.18-1.93h-9.5Z" />
    <path fill="#34A853" d="M12 22c2.7 0 4.97-.9 6.62-2.43l-3.27-2.54c-.9.6-2.05.95-3.35.95-2.57 0-4.75-1.73-5.53-4.06H3.1v2.62A9.98 9.98 0 0 0 12 22Z" />
    <path fill="#4A90E2" d="M6.47 13.92A5.99 5.99 0 0 1 6.16 12c0-.67.11-1.3.3-1.92V7.46H3.1A9.98 9.98 0 0 0 2 12c0 1.61.38 3.14 1.1 4.54l3.37-2.62Z" />
    <path fill="#FBBC05" d="M12 6.02c1.47 0 2.79.5 3.83 1.5l2.87-2.87C16.96 2.97 14.7 2 12 2A9.98 9.98 0 0 0 3.1 7.46l3.37 2.62C7.25 7.75 9.43 6.02 12 6.02Z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M23 12.2c0-2.13-.23-3.56-.6-4.45a2.93 2.93 0 0 0-2.06-2.06C19.45 5.3 12 5.3 12 5.3s-7.45 0-8.34.39A2.93 2.93 0 0 0 1.6 7.75C1.23 8.64 1 10.07 1 12.2c0 2.13.23 3.56.6 4.45a2.93 2.93 0 0 0 2.06 2.06c.89.39 8.34.39 8.34.39s7.45 0 8.34-.39a2.93 2.93 0 0 0 2.06-2.06c.37-.89.6-2.32.6-4.45ZM9.6 15.68V8.72L15.42 12 9.6 15.68Z" />
  </svg>
);

const GitHubIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M12 .5A11.5 11.5 0 0 0 .5 12.23c0 5.27 3.43 9.74 8.18 11.31.6.12.82-.27.82-.58v-2.05c-3.33.75-4.03-1.46-4.03-1.46-.55-1.42-1.34-1.8-1.34-1.8-1.1-.76.09-.74.09-.74 1.21.09 1.86 1.27 1.86 1.27 1.08 1.88 2.83 1.33 3.53 1.02.11-.8.42-1.33.77-1.64-2.66-.31-5.46-1.36-5.46-6.06 0-1.34.46-2.44 1.23-3.3-.13-.3-.53-1.56.11-3.24 0 0 1-.33 3.3 1.27a11.2 11.2 0 0 1 6 0c2.3-1.6 3.3-1.27 3.3-1.27.64 1.68.24 2.94.11 3.24.77.86 1.23 1.96 1.23 3.3 0 4.71-2.8 5.74-5.47 6.05.43.38.81 1.12.81 2.26v3.36c0 .31.22.71.82.58A11.74 11.74 0 0 0 23.5 12.23 11.5 11.5 0 0 0 12 .5Z" />
  </svg>
);

type BrandDefinition = {
  label: string;
  hosts: string[];
  iconClassName: string;
  Icon: () => JSX.Element;
};

const brandDefinitions: BrandDefinition[] = [
  {
    label: 'LinkedIn',
    hosts: ['linkedin.com'],
    iconClassName: 'text-[#0a66c2]',
    Icon: LinkedInIcon,
  },
  {
    label: 'Google',
    hosts: ['google.com'],
    iconClassName: '',
    Icon: GoogleIcon,
  },
  {
    label: 'Facebook',
    hosts: ['facebook.com', 'fb.com'],
    iconClassName: 'text-[#1877f2]',
    Icon: FacebookIcon,
  },
  {
    label: 'Twitter',
    hosts: ['twitter.com', 'x.com'],
    iconClassName: 'text-slate-950',
    Icon: XIcon,
  },
  {
    label: 'Instagram',
    hosts: ['instagram.com'],
    iconClassName: 'text-rose-500',
    Icon: InstagramIcon,
  },
  {
    label: 'YouTube',
    hosts: ['youtube.com', 'youtu.be'],
    iconClassName: 'text-rose-600',
    Icon: YouTubeIcon,
  },
  {
    label: 'GitHub',
    hosts: ['github.com'],
    iconClassName: 'text-slate-800',
    Icon: GitHubIcon,
  },
];

const genericBrand: BrandDefinition = {
  label: 'Website',
  hosts: [],
  iconClassName: 'text-slate-500',
  Icon: () => <Globe className={iconClassName} strokeWidth={1.8} />,
};

const hasProtocol = (value: string) => /^[a-z][a-z\d+\-.]*:\/\//i.test(value);

const normalizeExternalUrl = (url: string) => {
  const trimmed = url.trim();
  if (!trimmed) return '';
  return hasProtocol(trimmed) ? trimmed : `https://${trimmed}`;
};

const toDisplayHost = (host: string) => host.replace(/^(www\.|m\.|mobile\.)/i, '');

const matchesKnownHost = (host: string, candidates: string[]) =>
  candidates.some((candidate) => host === candidate || host.endsWith(`.${candidate}`));

const getBrandedLinkMeta = (url: string) => {
  const normalizedHref = normalizeExternalUrl(url);

  try {
    const parsedUrl = new URL(normalizedHref);
    const hostname = toDisplayHost(parsedUrl.hostname.toLowerCase());
    const brand = brandDefinitions.find((definition) => matchesKnownHost(hostname, definition.hosts)) ?? genericBrand;

    return {
      brand,
      label: brand === genericBrand ? hostname : brand.label,
      normalizedHref,
      title: hostname,
    };
  } catch {
    return {
      brand: genericBrand,
      label: url.trim(),
      normalizedHref,
      title: url.trim(),
    };
  }
};

type BrandedExternalLinkProps = {
  href: string;
  className?: string;
};

export const BrandedExternalLink = ({ href, className = '' }: BrandedExternalLinkProps) => {
  const { brand, label, normalizedHref, title } = getBrandedLinkMeta(href);

  if (!normalizedHref) {
    return null;
  }

  const Icon = brand.Icon;

  return (
    <a
      href={normalizedHref}
      target="_blank"
      rel="noreferrer"
      title={title}
      aria-label={label}
      className={`inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white transition hover:border-slate-300 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[rgb(var(--accent-solid))] ${className}`.trim()}
    >
      <span className={`inline-flex items-center justify-center ${brand.iconClassName}`}>
        <Icon />
      </span>
    </a>
  );
};
